import { render, staticRenderFns } from "./RastroMigas.vue?vue&type=template&id=661e31e6&scoped=true&"
import script from "./RastroMigas.vue?vue&type=script&lang=js&"
export * from "./RastroMigas.vue?vue&type=script&lang=js&"
import style0 from "./RastroMigas.vue?vue&type=style&index=0&id=661e31e6&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661e31e6",
  null
  
)

export default component.exports